import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/admin/src/lib/auth.tsx");
